import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';

import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    breadcrumbContainer: {
        listStyleType: 'none',
        padding: 0
    },
    breadcrumb: {
        display: 'inline',
        '&:not(:last-child)::after': {
            content: '" / "'
        }
    }
}));

const Breadcrumbs = ({ items }) => {
    const classes = useStyles();
    return (
        <ul className={classes.breadcrumbContainer}>
            {
                items.map(o => (
                    <li className={classes.breadcrumb} key={o.label}>
                        {
                            o.url
                                ? <Link to={o.url}>{o.label}</Link>
                                : o.label
                        }
                    </li>
                ))
            }
        </ul>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.array.isRequired
};

export default Breadcrumbs;
